import { render, staticRenderFns } from "./SmallLoaderLight.vue?vue&type=template&id=0d318055&scoped=true&"
import script from "./SmallLoaderLight.vue?vue&type=script&lang=js&"
export * from "./SmallLoaderLight.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoaderLight.vue?vue&type=style&index=0&id=0d318055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d318055",
  null
  
)

export default component.exports